import React, { FC } from 'react';
import Text from 'Components/Typography/Text';
import { Box } from '@igooods/ui-kit';
import styled from 'styled-components';
import MobileInterfaceImg from './images/interface-mobile.png';
import MobileInterfaceRetinaImg from './images/interface-mobile@2x.png';
import DesktopInterfaceImg from './images/interface-desk.png';
import DesktopInterfaceRetinaImg from './images/interface-desk@2x.png';
import BlockContainer from 'Components/landings/BlockContainer';
import { colors } from 'constants/colors';
import BlockTitle from 'Components/landings/BlockTitle';
import { mediaSmDown, mediaMdDown, mediaLgDown } from 'theme/helpers/css';
import { Flex } from '@igooods/ui-kit';
import { FontSize } from 'theme';

const Block = styled(Flex).attrs({
  between: true,
  top: true,
})`
  min-height: 530px;
  position: relative;
  box-sizing: content-box;

  ${mediaLgDown`
    min-height: 432px;
  `}

  ${mediaSmDown`
    flex-direction: column;
  `}
`;

const Banner = styled.div`
  position: absolute;
  width: 462px;
  left: 44%;
  bottom: 0;
  transform: translateX(-50%);

  ${mediaLgDown`
    width: 317px;
  `}

  ${mediaMdDown`
    left: 40%;
  `}

  ${mediaSmDown`
    position: static;
    margin-top: 48px;
    order: 3;
    width: min(74%, 205px);
    transform: none;
    align-self: center;
  `}

  img,
  picture {
    width: 100%;
  }
`;

const TopBlock = styled(Box)`
  max-width: 400px;
  z-index: 2;

  ${mediaLgDown`
    max-width: 224px;
  `}

  ${mediaSmDown`
    max-width: none;
    order: 1;
  `}
`;

const BottomBlock = styled(Box)`
  align-self: flex-end;
  max-width: 355px;
  z-index: 2;

  ${mediaLgDown`
    max-width: 235px;
  `}

  ${mediaSmDown`
    max-width: none;
    margin-top: 40px;
    order: 2;
  `}
`;

const BlockDescription = styled(Text).attrs({
  size: FontSize.m,
})`
  margin-top: 28px;

  ${mediaLgDown`
    font-size: 14px;
    line-height: 22px;
    margin-top: 18px;
  `}
`;

const InterfaceBlock: FC = () => {
  return (
    <BlockContainer bgColor={colors.white}>
      <Block pt={{ xs: 12, sm: 14, lg: 30 }} pb={{ sm: 14, lg: 40 }}>
        <TopBlock>
          <h3>
            <BlockTitle>Привычные товары и&nbsp;цены</BlockTitle>
          </h3>
          <BlockDescription>
            Более 30&nbsp;000 товаров в&nbsp;каталоге&nbsp;— выбирать удобно и&nbsp;быстро.
          </BlockDescription>
        </TopBlock>
        <Banner>
          <picture>
            <source media="(max-width: 1023px)" srcSet={`${MobileInterfaceRetinaImg} 2x, ${MobileInterfaceImg} 1x`} />
            <source media="(min-width: 1024px)" srcSet={`${DesktopInterfaceRetinaImg} 2x, ${DesktopInterfaceImg} 1x`} />
            <img src={DesktopInterfaceImg} alt="" data-loading="lazy" />
          </picture>
        </Banner>
        <BottomBlock>
          <h3>
            <BlockTitle>Донесем тяжелые пакеты</BlockTitle>
          </h3>
          <BlockDescription>
            Однажды наш курьер Игорь доставил заказ весом 80&nbsp;кг. Если нужно&nbsp;&mdash; привезем вам
            столько&nbsp;же.
          </BlockDescription>
        </BottomBlock>
      </Block>
    </BlockContainer>
  );
};

export default InterfaceBlock;
